import { BLOCKS } from '@contentful/rich-text-types';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import React, { ReactNode } from 'react';

import { CHANNEL } from '@boss/constants/corporate-jobs';
import { RichText } from '@boss/rich-text';
import {
  ButtonPosition,
  PromotionCtaColorVariant,
  PromotionCtaFields,
  PromotionCtaVariant,
  PromotionCtaVariantb2b,
  PromotionCtaVariantb2c,
  SimpleImage,
} from '@boss/types/corporate-jobs';
import { Image as CfImage } from '@boss/ui';

import ComponentMapper from '../ComponentMapper';

import { getButtonProps } from './index';

const getPromotionCtaProps = (
  entry: PromotionCtaFields,
  locale: string,
): {
  cta: {
    anchorClassName: string;
    href: string;
    icon: undefined | IconDefinition;
    iconPosition: 'left' | 'right';
    label: string;
    type: 'primary' | 'secondary' | 'tertiary' | 'link';
  };
  children: ReactNode;
  variant: PromotionCtaVariant;
  colorVariant: PromotionCtaColorVariant;
  image?: SimpleImage;
  buttonPosition: ButtonPosition;
  imagePosition?: 'left' | 'right' | 'full-width-background';
} => {
  const { image, text, cta, imagePosition, ctaPosition, variation } = entry;
  let variantProps: {
    variant: PromotionCtaVariantb2b | PromotionCtaVariantb2c;
    colorVariant: PromotionCtaColorVariant;
  };

  const baseProps = {
    cta: getButtonProps(cta, locale),
    children: text ? (
      <RichText
        ComponentMapper={ComponentMapper}
        content={text}
        mapperOptions={{ locale }}
        renderNode={{
          [BLOCKS.PARAGRAPH]: (_, children) => {
            return <p>{children}</p>;
          },
          [BLOCKS.EMBEDDED_ENTRY]: _ => {
            if (_.data.target.__typename === 'image') {
              return <CfImage alt={_.data.target.title} className="w-auto max-w-full" image={_.data.target.image} />;
            }
          },
        }}
        renderOptions={{ noWrapper: true }}
      />
    ) : null,
  };

  if (CHANNEL === 'jobs-b2c') {
    variantProps = {
      variant: 'b2c',
      colorVariant: 'beige',
    };
  } else {
    if (variation === 'rounded-corners') {
      variantProps = {
        variant: 'b2c',
        colorVariant: 'green',
      };
    } else {
      variantProps = {
        variant: 'b2b',
        colorVariant: 'green',
      };
    }
  }

  if (image) {
    return {
      ...baseProps,
      ...variantProps,
      image: { id: image.id, imageUrl: image.image.file.url, imageAlt: image.altText ?? '' },
      buttonPosition: imagePosition === 'full-width-background' ? ctaPosition : 'bottom',
      imagePosition,
    };
  } else {
    return {
      ...baseProps,
      ...variantProps,
      buttonPosition: ctaPosition,
    };
  }
};

export default getPromotionCtaProps;
